import { Component, OnInit, Input } from '@angular/core';
import { NguCarousel } from '@ngu/carousel';

@Component({
  selector: 'app-testimonials-carousel',
  templateUrl: './testimonials-carousel.component.html',
  styleUrls: ['./testimonials-carousel.component.scss']
})
export class TestimonialsCarouselComponent implements OnInit {
  @Input('backgroundGray') public backgroundGray;
  public carouselOptions: NguCarousel;
  public testimonials = [{
    logo: 'assets/images/zz/partner-3.png',
    url: 'http://aristo.expert/'
  }, {
    logo: 'assets/images/zz/partner-4.png',
    url: 'https://www.grass.at/'
  }, {
    logo: 'assets/images/zz/partner-1.png',
    url: 'http://mdm-complect.ru/'
  }, {
    logo: 'assets/images/zz/partner-9.png',
    url: 'https://www.bazissoft.ru/'
  }, {
    logo: 'assets/images/zz/partner-2.png',
    url: 'http://tbm.ru/'
  }, {
    logo: 'assets/images/zz/partner-5.png',
    url: 'http://hettich.com/'
  }, {
    logo: 'assets/images/zz/partner-6.png',
    url: 'http://samet.com.tr/'
  }, {
    logo: 'assets/images/zz/partner-7.png',
    url: 'http://depo.lv/'
  }, {
    logo: 'assets/images/zz/partner-8.png',
    url: 'http://modern-st.ru/'
  }]
  constructor() { }

  ngOnInit() {
    this.carouselOptions = {
      grid: { xs: 1, sm: 2, md: 3, lg: 3, all: 0 },
      slide: 2,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true
    }
  }

}
